import { Exception } from '../Exception';

/** An existing bug in Outlook Web can cause the Outlook server to respond with "GenericResponseError"
 * when user selects an appointment in his inbox after he selects a message,
 * and our app tries to perform any operation on the selected item
 * REF: https://github.com/OfficeDev/office-js/issues/1869 */
export class OutlookWrongItemSelectedException extends Exception {
  constructor(error: Office.Error) {
    const message =
      "This error might occur when selected outlook item has changed to an item that isn't supported." +
      'Please try to select a different item. If the issue persist, contact our support.';
    super(message, error);
  }
}
